import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import DiarioService from '../../../../services/diario';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");
    const [palavra, setPalavra] = useState("");
    const [mostra, setMostra] = useState(true);
    const pathName = window.location.pathname;

    const getTipo = (path) => {
        switch (path) {
            case '/transparencia/diario/expomacuco/2025':
                setAno("2025");
                setMostra(false);
                return { service: DiarioService.buscarExpo, type: "object" };

            case '/transparencia/diario/expomacuco/2024':
                setAno("2024");
                setMostra(false);
                return { service: DiarioService.buscarExpo, type: "object" };

            case '/transparencia/diario/expomacuco/2023':
                setAno("2023");
                setMostra(false);
                return { service: DiarioService.buscarExpo, type: "object" };

            case '/transparencia/diario/expomacuco/anteriores':
                setAno("2022");
                setMostra(false);
                return { service: DiarioService.buscarExpo, type: "object" };

            default:
                setMostra(true);
                return { service: DiarioService.buscar, type: "string" };
        }
    };



    const busca = async (query) => {
        props.setAguardando(true)
        if (query === "") {
            props.setAguardando(false)
            await props.fetchDiariosIn()
            setMes("")
            setPalavra("")
        } else {
            const { service, type } = getTipo(pathName);
            let response;
            if (type === "object") {
                // services buscarExpo e buscarExpoAnt
                response = await service(ano ? { ano, ...query } : query);
            } else {
                // service buscar → já espera string completa
                response = await service(query);
            }
            if (response.data.length >= 1) {
                props.setDiarios(response.data)
                props.setAguardando(false)
                props.setVazio(false)
                setMes("")
                setPalavra("")
            } else {
                props.setVazio(true)
                props.setAguardando(false)
                setMes("")
                setPalavra("")
            }
        }
    }

    const preparaQuery = async () => {
        let queryObj = {};
        let queryStr = "";
        if (mes !== "false" && mes !== "") {
            queryObj.mes = mes;
            queryStr += `&mes=${encodeURI(mes)}`;
        }
        if (ano) {
            queryObj.ano = ano;
            queryStr += `&ano=${ano}`;
        }
        if (palavra) {
            queryObj.objeto = palavra;
            queryStr += `&palavra=${encodeURIComponent(palavra)}`;
        }
        return { queryObj, queryStr };
    }

        const handleKeyDown = async (e) => {
            e.preventDefault();
            let { queryObj, queryStr } = await preparaQuery();
    
            const { service, type } = getTipo(pathName);
    
            if (type === "object") {
                await busca(queryObj);
            } else {
                await busca(queryStr);
            }
        };
        useEffect(() => {
            getTipo(window.location.pathname);
        }, [window.location.pathname]);

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Mês">
                                <FloatingLabel
                                    label="Mês"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Mês"
                                        name="mes"
                                        onChange={e => setMes(e.target.value)}
                                    >
                                        <option value="false">TODOS</option>
                                        <option value="1">Janeiro</option>
                                        <option value="2">Fevereiro</option>
                                        <option value="3">Março</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Maio</option>
                                        <option value="6">Junho</option>
                                        <option value="7">Julho</option>
                                        <option value="8">Agosto</option>
                                        <option value="9">Setembro</option>
                                        <option value="10">Outubro</option>
                                        <option value="11">Novembro</option>
                                        <option value="12">Dezembro</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {mostra ? 
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col> : null }
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Palavra-chave">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="palavra"
                                        value={palavra}
                                        onChange={e => setPalavra(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.diarios} nome={"Diarios"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#049b887b-0fea-41b0-b8c1-4a5fc1beb946" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca